'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbForm.$inject = ['$parse', '$window', 'UrlParamService'];


var _module = _angular2.default.module('cb.core.forms.cbForm', []);

_module.directive('cbForm', cbForm);

exports.default = _module;

/**
 * cb-form
 *
 * Add this directive to emulate a <form> tag where the tag cannot be used.
 * This is necessary on SharePoint environments.  Use in addition to
 * ng-form.  See also, cb-submit.
 *
 * Currently simulates a GET on the action attribute, using parameters
 * specified in the queryparams attribute.  Does not support the method
 * attribute.  You need to specify cb-submit="submit()".
 *
 * To set a new action on the form use
 * angular.element('div[ng-form="nameOfForm"').scope().nameOfFormAction = '/newUrl'
 *
 * To set extra query params on the form use
 * angular.element('div[ng-form="licenseplateForm"').scope().nameOfFormQueryParams = '{"key": "value"}'
 *
 */

function cbForm($parse, $window, UrlParamService) {
    function buildUrl(baseUrl, queryParams) {
        var url = baseUrl;

        _angular2.default.forEach(queryParams, function (value, property) {
            if (typeof value === 'undefined') {
                delete queryParams[property];
            }
        });

        //If url does not contain url params yet, add '?'
        if (url.substring(url.lastIndexOf('/')).indexOf('?') === -1) {
            url += '?';
        }

        //Url encode query params
        if (queryParams !== {}) {
            url += UrlParamService.urlEncode(queryParams);
        }

        return url;
    }

    return {
        restrict: 'A',
        scope: true,
        link: function link(scope, element, attrs) {

            scope.submit = function () {
                var baseUrl = scope[attrs.ngForm + 'Action'] || attrs.action;
                var queryParams = $parse(attrs.queryparams)(scope) || {};

                if (scope[attrs.ngForm + 'QueryParams']) {
                    var _queryParams = $parse(scope[attrs.ngForm + 'QueryParams'])(scope);
                    queryParams = _angular2.default.merge(queryParams, _queryParams);
                }

                var url = buildUrl(baseUrl, queryParams);

                $window.location.href = url;

                // Return for testability.
                return url;
            };
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/forms/cb-form.directive.js
// module id = 777
// module chunks = 0